export default __webpack_public_path__ + "static/22-50dd10be5ecc48155486f1216468de72.png";